import React, { useState } from "react";
import { Button, Checkbox, Modal } from "../../BP2Components";
import IntlMessages from "../../../util/IntlMessages";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "../../../appRedux/actions/Boards";
import "./ButtonEndModal.less";

interface ButtonConfirmModalProps {
   open: boolean;
   onClose: (boolean) => {};
   props: any;
}

const ButtonConfirmModal: React.FC<ButtonConfirmModalProps> = ({ onClose, open, props }) => {
   const [settings, setSettings] = useState({ ...props });

   const history = useHistory();
   const dispatch = useDispatch();

   const handleCancel = (e) => {
      handelSaveSettings(e);
      onClose(false);
   };

   const routeChange = () => {
      const currentPath = window.location.pathname;
      const targetPath = props.customButtonUrl;

      if (currentPath === targetPath) {
         window.location.reload();
      } else {
         history.push(targetPath);
      }
   };

   const openInNewWindow = () => {
      window.open(`${props.customButtonUrl}`);
   };

   const handleInputChange = (fieldName, value) => {
      setSettings((prevSettings) => ({
         ...prevSettings,
         [fieldName]: value
      }));
   };

   const handelSaveSettings = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
   };

   return (
      <>
         <Modal
            width={window.innerWidth / 2}
            height={window.innerHeight / 1.8}
            topBarStyles={{ borderBottom: "none" }}
            bodyStyles={{ textAlign: "center", position: "relative" }}
            topBarContent={
               <Button onClick={handleCancel} className="end-modal-exit-button">
                  <span className="material-icons">clear</span>
               </Button>
            }
            isOpen={open}
         >
            <div className="confirm-modal-main-container">
               <div className="confirm-modal-text-container">
                  <h3>
                     <IntlMessages id={props?.title} />
                  </h3>
                  <h6>
                     <IntlMessages id={props?.description} />
                  </h6>
               </div>
               <div className="end-modal-checkbox">
                  <label style={{ marginLeft: "20px" }}>
                     <IntlMessages id="button.end.modal.dontShowModal" />
                  </label>
                  <Checkbox
                     onChange={(e) => handleInputChange("showEndingModal", e.target.checked)}
                  />
               </div>

               <div className="confirm-modal-buttons">
                  <Button
                     className="end-modal-buttons content-end-modal-button"
                     onContextMenu={openInNewWindow}
                     onClick={routeChange}
                  >
                     <IntlMessages id={props?.customButtonTitle} />
                  </Button>
                  <Button
                     className="end-modal-buttons close-end-modal-button"
                     onClick={(e) => handleCancel(e)}
                  >
                     <IntlMessages id={props?.closeButtonTitle} />
                  </Button>
               </div>
            </div>
         </Modal>
      </>
   );
};

export default ButtonConfirmModal;
